import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { mediaUrl, baseURL } from "../axiosInterceptor/axiosInterceptorC";
import axios from "axios";

  export const fetchProjects = createAsyncThunk(
    "projects/fetchProjects",
    async ({ companyName, status }, { rejectWithValue }) => {
      try {
        const response = await axios.post(`${baseURL}/builder/fetchprojectDeatils`, {
          companyName: companyName,
          status_val: status,
        });
        console.log(response.data)
        return response.data;
      } catch (error) {
        return rejectWithValue(error.response?.data || "Something went wrong");
      }
    }
  );

  const projectSlice = createSlice({
    name: "projects",
    initialState: {
      data: [],  // ✅ Change null to []
      loading: false,
      error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
      builder
        .addCase(fetchProjects.pending, (state) => {
          state.loading = true;
          state.error = null;
        })
        .addCase(fetchProjects.fulfilled, (state, action) => {
          state.loading = false;
          state.data = action.payload || [];  // ✅ Always ensure it's an array
        })
        .addCase(fetchProjects.rejected, (state, action) => {
          state.loading = false;
          state.error = action.payload || "Failed to fetch projects";
        });
    },
  });
  

export default projectSlice.reducer;
